import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentsHandoff } from '@/pages/workspaces/segments/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

// `/workspaces/last` must resolve before the embedded app mounts.
function JourneysSegmentsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSegmentsHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/')({
  component: JourneysSegmentsIndexRoute,
});
